import React, { Component } from 'react';

import Infinite from 'react-infinite';
import { TargetItem, Button, Loading } from 'components';
import { injectIntl, defineMessages } from 'react-intl';
import { Segment, Grid, Icon, Form, Image, Input, Dropdown, Popup } from 'semantic-ui-react';

import styles from './TargetList.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class TargetList extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const filterUpdateCheck = this.props.filterUpdate;
    if (filterUpdateCheck) {
      return filterUpdateCheck;
    } else {
      return filterUpdateCheck;
    }
  }

  // 태그 선택시 대상자 rerender 처리
  componentDidUpdate(prevProps, prevState) {
    // 대상자 Height 설정
    // 데이터가 없으면 rf.scrollable이 아예 생성 안됨
    const rf = this.refScroll;
    if (!!rf && !!rf.scrollable) {
      const { heightData, numberOfChildren } = rf.state.infiniteComputer;
      const isScroll = heightData * numberOfChildren > rf.scrollable.parentElement.clientHeight;

      // 높이가 달라진 경우
      // 스크롤이 생성 여부
      if (
        rf.computedProps.containerHeight !== rf.scrollable.parentElement.clientHeight ||
        isScroll !== this.state.targetScrollData['isScroll']
      ) {
        this.setState({
          targetScrollData: { isScroll: isScroll, height: rf.scrollable.parentElement.clientHeight }
        });
      }
    }

    const { needReload, selectedTag, targetParam } = this.props;
    if (
      // 대상자 새로고침
      (needReload && !this.state.isLoading) ||
      // 선택한 태그가 변경되었을 때
      selectedTag !== prevProps.selectedTag ||
      // parameter가 변경되었을때
      targetParam !== prevProps.targetParam
    ) {
      this.onGetTarget(true);

      // 새로고침시 스크롤 맨위로 이동
      if (!!rf && !!rf.scrollable) {
        rf.scrollable.scrollTop = 0;
        // rf.infiniteHandleScroll(0);
        // rf.handleScroll(0);
      }
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const {
      targetOrdering,
      tagDataByTagNo,
      targetDataByTargetNo,
      selectTarget,
      handleCheckTarget,
      handleSelectTarget,
      targetScrollData,
      onRefScroll,
      page,
      totalPages,
      onGetTarget,
      isLoading
    } = this.props;

    const targetComponent = targetOrdering.map(
      // 컴포넌트로 매핑
      (targetNo, i) =>
        !!targetDataByTargetNo.get(String(targetNo)) && (
          <TargetItem
            key={i}
            tagDataByTagNo={tagDataByTagNo}
            target={targetDataByTargetNo.get(String(targetNo))}
            selectTarget={selectTarget}
            handleCheckTarget={handleCheckTarget}
            handleSelectTarget={handleSelectTarget}
          />
        )
    );
    return (
      <div className={cx('target-content')}>
        <div className={cx('target-content-inner')}>
          {targetComponent.size > 0 ? (
            <Infinite
              className={cx({ noScroll: !targetScrollData['isScroll'] })}
              ref={Infinite => {
                onRefScroll(Infinite);
              }}
              containerHeight={targetScrollData['height']}
              elementHeight={42}
              infiniteLoadBeginEdgeOffset={200}
              timeScrollStateLastsForAfterUserScrolls={1000}
              onInfiniteLoad={page !== totalPages ? onGetTarget : () => { }}
              loadingSpinnerDelegate={
                isLoading && (
                  <div className={cx('targetLoading')}>
                    <Loading content={'Loading...'} />
                  </div>
                )
              }
              isInfiniteLoading={isLoading}>
              {targetComponent}
            </Infinite>
          ) : (
              <div className={cx('noScroll', 'noTarget')}>
                <div className={cx('noScroll-icon-area')}>
                  <Image src="/img/exam/list_noTarget.png" />
                </div>
                <div className={cx('')}>
                  <div className={cx('noScroll-title')}>
                    {defineMessages(formatMessage({ id: 'Target_15', defaultMessage: '대상자가 없습니다' }))}
                  </div>
                  <div className={cx('noScroll-subTitle')}>
                    {defineMessages(formatMessage({ id: 'Target_16', defaultMessage: '대상자를 추가하세요' }))}
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default injectIntl(TargetList);



// WEBPACK FOOTER //
// ./src/script/components/target/TargetList.js